import BaseAPI from '../base'

function getWarehouses(city) {
    return BaseAPI.get(`shipment/warehouses/${city}`);
}

function putOrder(data) {
    return BaseAPI.post(`shipment/order`, data);
}

function query(cafe_id) {
    return BaseAPI.get(`shipment/query/${cafe_id}`);
}

function getDeliveryStatus(ttn) {
    return BaseAPI.get(`shipment/delivery_status/${ttn}`);
}

function uploadCustomTemplate(img) {
    let fd = new FormData();
    fd.append('template', img);

    return BaseAPI.root.post(`shipment/upload_custom_template`, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

function getArchive(cafe_id) {
    return BaseAPI.get(`shipment/archive/${cafe_id}`);
}

export default {
    getWarehouses,
    putOrder,
    query,
    getDeliveryStatus,
    getArchive,
    uploadCustomTemplate
}